import { LoadingSpinnerWithImage } from 'Components/designSystem';
import React, { memo, PropsWithChildren } from 'react';
import { HEADER_HEIGHT } from 'shared/constants';
import styled from 'styled-components';

import { Tenant } from '../types';
import { default as Error, ErrorProps } from './error';
import Footer from './Footer';
import { default as Header } from './header';
import Success from './Success';

export interface SuccessProps {
    success: boolean;
    tenant: Tenant | null;
}

interface PageContentWrapperProps {
    status: 'loading' | 'error' | 'ready' | 'success' | undefined ;
    errorProps: ErrorProps;
    successProps: SuccessProps;
    tenant: Tenant | null;
    withSidebar?: boolean
}

const PageContentWrapper = (props: PropsWithChildren<PageContentWrapperProps>) => {
    const { status, errorProps, children, tenant, withSidebar } = props;

    const renderPageBody = () => {
        if (!status) {
            return null;
        }

        if (status === 'loading') {
            return <LoadingSpinnerWithImage portal />;
        }

        if (status === 'error' || errorProps.isExpired) {
            return (
                <Error tenant={ errorProps.tenant }
                    error={ errorProps.error }
                    isExpired={ errorProps?.isExpired ?? false }
                />
            );
        }

        if (status === 'success') {
            return (
                <Success successText={ tenant?.candidateSuccessText } />
            );
        }

        return (
            <>
                { children }
            </>
        );
    };

    return (
        <>
            <Header logoUrl={ tenant?.logoTypeUri }
                withLogo
            />

            <BodyWrapper>
                { renderPageBody() }
            </BodyWrapper>

            <Footer withSidebar={ withSidebar }/>
        </>
    );
};

const BodyWrapper = styled.div`
    padding-top: ${ HEADER_HEIGHT }px;
`;

export default memo(PageContentWrapper);
